import React from 'react';
import dynamic from 'next/dynamic';
import styles from './Player.module.scss';

// ssr: false — react-player/lazy renders null on server but Suspense on client, causing hydration mismatch
const ReactPlayer = dynamic(() => import('react-player/lazy'), { ssr: false });

export interface PlayerProps {
	url: string;
	isLight?: boolean;
	poster?: string;
	playing?: boolean;
	loop?: boolean;
	controls?: boolean;
}

export const Player: React.FC<PlayerProps> = ({ url, isLight = true, poster, playing = false, loop = false, controls = true }) => {
	const light = !isLight ? false : poster ? poster : true;

	return (
		<ReactPlayer
			url={url}
			className={styles.Player}
			light={light}
			playing={playing}
			loop={loop}
			controls={controls}
			width="100%"
			height="100%"
			config={{
				youtube: {
					playerVars: { modestbranding: 1 },
				},
			}}
		/>
	);
};
